export default function BlogListCard(card_data) {

    return (
        <section class="b-post b-post-full b-post-cover  clearfix">
            <div class="entry-media">
                <span class="decore-lt"></span>
                <span class="decore-rt"></span>
                <span class="decore-rb"></span>
                <a href={'/blog/' + card_data.data.url}><img class="img-fluid" src={"/images/blog/"+card_data.data.url+".png"} alt="Foto" /></a>
                <div class="entry-meta">
                    {card_data.data.short_desc === "" ? (
                        <h1 class="entry-title" > <a href={'/blog/' + card_data.data.url}>{card_data.data.title}</a></h1>
                    ) : (
                       null
                    )}

                    

                    <span class="entry-meta__item">{card_data.data.date}</span>
                    {/* <span class="entry-meta__item"><a class="entry-meta__link" href={'/blog/' + card_data.data.url}><i class="ic icon-speech"></i>53</a></span> */}
                </div>
            </div>
            {card_data.data.short_desc && (
                <div class="entry-main">
                    <div class="entry-content">
                        <h1 class="entry-title" ><a href={'/blog/' + card_data.data.url}>{card_data.data.title}</a></h1>
                        <p>{card_data.data.short_desc}<a class="more_post"
                                        style={{
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 2,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }} href={'/blog/' + card_data.data.url}><i class="ico_more"></i></a></p>
                    </div>
                </div>
            )}
        </section>


    );
}